import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import AppLayout from "./components/AppLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AskPramaana from "./pages/AskPramaana";
import Constitution from "./pages/Constitution";
import DecisionLedger from "./pages/DecisionLedger";
import OpenQuestions from "./pages/OpenQuestions";
import Sources from "./pages/Sources";
import Conversations from "./pages/Conversations";
import ClaimReview from "./pages/ClaimReview";
import KnowledgeHistory from "./pages/KnowledgeHistory";
import ReviewQueue from "./pages/ReviewQueue";

// Public Pramaana verification product (C1)
import PublicLayout from "./pd/PublicLayout";
import Landing from "./pd/Landing";
import DevoteeJourney from "./pd/DevoteeJourney";
import TempleManager from "./pd/TempleManager";
import Validation from "./pd/Validation";
import VerifiedRecords from "./pd/VerifiedRecords";
import RecordDetail from "./pd/RecordDetail";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function Public({ children }) {
  return <PublicLayout>{children}</PublicLayout>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public verification product */}
            <Route path="/" element={<Public><Landing /></Public>} />
            <Route path="/devotee" element={<Public><DevoteeJourney /></Public>} />
            <Route path="/temple-manager" element={<Public><TempleManager /></Public>} />
            <Route path="/validation" element={<Public><Validation /></Public>} />
            <Route path="/records" element={<Public><VerifiedRecords /></Public>} />
            <Route path="/records/:rid" element={<Public><RecordDetail /></Public>} />
            <Route path="/verified-records/:rid" element={<Public><RecordDetail share /></Public>} />

            {/* Founder / Admin (private) */}
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin/ask" element={<Protected><AskPramaana /></Protected>} />
            <Route path="/admin/review" element={<Protected><ReviewQueue /></Protected>} />
            <Route path="/admin/constitution" element={<Protected><Constitution /></Protected>} />
            <Route path="/admin/decisions" element={<Protected><DecisionLedger /></Protected>} />
            <Route path="/admin/open-questions" element={<Protected><OpenQuestions /></Protected>} />
            <Route path="/admin/sources" element={<Protected><Sources /></Protected>} />
            <Route path="/admin/conversations" element={<Protected><Conversations /></Protected>} />
            <Route path="/admin/claims" element={<Protected><ClaimReview /></Protected>} />
            <Route path="/admin/history" element={<Protected><KnowledgeHistory /></Protected>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
